/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the SDUAUserInformation
 *
 * @class SDUAUserInformation
 */
class SDUAUserInformation {
  /**
   * Creates an instance of SDUAUserInformation.
   * @param {*} json
   * @memberof SDUAUserInformation
   */
  constructor(json = null) {
    if (json) {
      // string
      this.identifiedIC = json.identifiedIC;

      // boolean
      this.isIDProofed = json.isIDProofed;

      // string
      this.userRole = json.userRole;

      // boolean
      this.linkAcctRequestInd = json.linkAcctRequestInd;

      // string
      this.userType = json.userType;
    }
  }
}

/**
 * Models the SDUAUserLocalOfficeAddress
 *
 * @class SDUAUserLocalOfficeAddress
 */
class SDUAUserLocalOfficeAddress {
  /**
   * Creates an instance of SDUAUserLocalOfficeAddress.
   * @param {*} json
   * @memberof SDUAUserLocalOfficeAddress
   */
  constructor(json = null) {
    if (json) {
      // string
      this.officeName = json.officeName;

      // string
      this.street1 = json.street1;

      // string
      this.street2 = json.street2;

      // string
      this.city = json.city;

      // string
      this.zipCode = json.zipCode;

      // string
      this.emailAddress = json.emailAddress;

      // string
      this.fax = json.fax;

      // string
      this.phone = json.phone;

      // string
      this.state = json.state;

      // string
      this.phone800 = json.phone800;
    }
  }
}

export default {
  SDUAUserInformation,

  SDUAUserLocalOfficeAddress,
};
